import appFleet from "../../views/appFleet/buses.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "buses";
  const params = ["page", "limit", "type", "company", "city"];

  $stateProvider.state("buses", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appFleet,
      },
    },
    reloadOnSearch: false,
    data: { title: "Buses" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/buses/buses.urls.js